import {Howl} from "howler";
import * as PIXI from "pixi.js";
import {PredefinedPIXIAnchorPoint} from "../../PredefinedPIXIAnchorPoint";
import data from "../configs/data";
import {Utils} from "../Utils";

export class ChipsStack extends PIXI.Container {

    private tokenValuesTextures: Array<PIXI.Texture> = [];
    private tokenValues: Array<number>;
    private stackValue = 0;
    private previousStackValue = 0;
    private firstTokenSound: Howl;
    private nextTokensSound: Howl;
    private readonly TOKENS_OFFSET = 2;
    private readonly CHIPS_STACKS_SCALE = new PIXI.Point(0.9, 0.9);
    private readonly VALUE_LABEL_POSITION = new PIXI.Point(0, 20);
    private readonly VALUE_TEXT_STYLE = {
        fontSize: 16,
        fontFamily: "RobotoMedium",
        fill: "#fff",
        fontWeight: "bolder",
        strokeThickness: 2,
    };

    constructor(tokenValuesPath: Array<string>, tokenValues: Array<number>) {
        super();
        this.scale = this.CHIPS_STACKS_SCALE;
        if (tokenValuesPath.length !== tokenValues.length) {
            throw new Error("Entry arrays do not match!");
        }
        for (let i = 0; i < tokenValuesPath.length; i++) {
            this.tokenValuesTextures.push(PIXI.Texture.fromFrame(tokenValuesPath[i]));
        }
        this.tokenValues = tokenValues;
        this.firstTokenSound = new Howl({
            src: [data.audios.firstChipPut],
            volume: 0.8,
        });
        this.nextTokensSound = new Howl({
            src: [data.audios.nextChipPut],
            volume: 0.8,
        });
    }

    public setStack(value: number): void {
        this.stackValue = value;
        let tokensAmount = 0;
        let currentTokenOffset = this.TOKENS_OFFSET;
        let sprite;
        let remainingValue = value;

        if (value !== 0) {
            if (this.previousStackValue === 0) {
                this.firstTokenSound.play();
            } else {
                this.nextTokensSound.play();
            }
        }

        this.previousStackValue = value;
        this.removeChildren();

        for (let i = 0; i < this.tokenValues.length; i++) {
            tokensAmount = Math.floor(Utils.roundWithPrecision(remainingValue / this.tokenValues[i], 3));
            remainingValue -= tokensAmount * this.tokenValues[i];
            remainingValue = Utils.roundWithPrecision(remainingValue, Utils.getBetPrecision());
            for (let j = 0; j < tokensAmount; j++) {
                sprite = new PIXI.Sprite(this.tokenValuesTextures[i]);
                sprite.position.y = currentTokenOffset;
                sprite.anchor = PredefinedPIXIAnchorPoint.CENTER;
                currentTokenOffset -= this.TOKENS_OFFSET;
                this.addChild(sprite);
            }
        }
        if (value !== 0) {
            this.createAndAddValueLabel(value);
        }
    }

    public getStackValue(): number {
        return this.stackValue;
    }

    private createAndAddValueLabel(value: number): void {
        this.createAndAddLabelBackground();
        const valueLabel = new PIXI.Text(value.toFixed(Utils.getBetPrecision()), this.VALUE_TEXT_STYLE);
        valueLabel.position = this.VALUE_LABEL_POSITION;
        valueLabel.anchor = PredefinedPIXIAnchorPoint.CENTER;
        this.addChild(valueLabel);
    }

    private createAndAddLabelBackground(): void {
        const background: PIXI.Sprite = PIXI.Sprite.fromImage(data.images.betValueBackground);
        background.position = this.VALUE_LABEL_POSITION;
        background.anchor = PredefinedPIXIAnchorPoint.CENTER;
        this.addChild(background);
    }
}



// WEBPACK FOOTER //
// ./src/app/userInterface/ChipsStack.ts